/* import __COLOCATED_TEMPLATE__ from './date-review.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SharedQuestionnaireDateReview extends Component {}
